/**
 * 1. `^\/+` Remove all slashes from the beginning
 * 2. `(\/)\1+$` Remove all but one slash at the end
 *
 * `///foo///` to `foo/`
 *
 * @example
 * ```
 * string.replace(slashReg, '$1')
 * ```
 */
export const slashReg = /^\/+|(\/)\1+$/gi
// Targets slashes at the beginning of a string
export const frontSlashReg = /^\/\/*/i
export const endSlashReg = /\/\/*$/i
export const protocolReg = /^(https?:\/\/)\1*/i
export const ftpReg = /^(s?ftp:\/\/)\1*/i

// Stolen from here: https://regex101.com/r/d7YuFt/1
export const domainNameReg =
  /^\b((?=[a-z0-9-]{1,63}\.)(xn--)?[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}\b/

// Stolen from here: https://stackoverflow.com/a/27434991
export const ipReg =
  /^(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])$/

/**
 * Starts with a non-letter or number character
 */
export const specialCharReg = /^[^A-Za-z 0-9\u00C0-\u024F\u1E00-\u1EFF]/
